<template>
    <div>
        <app-form 
            v-bind:parentObject = "{
                data: this.formData,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.editMode
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            />
        </div>    
    </div>
</template>

<script>
import LeaveBalanceSummaryForm from '../../../components/leave/leavebalancesummary/Form_Parameter';
import ErrorDialog from '../../../components/common/ErrorDialog';
import moment from 'moment';


export default {
    components: {
        'app-form': LeaveBalanceSummaryForm,
        'app-error': ErrorDialog
    },

    data() {
            return{
                pageTitle: this.$t('leavebalancesummary'),
                pageTitleValue: '',
                
                formData: {
                    asofdate: moment().format("YYYY-MM-DD"),
                    leavetypeid: null,
                    leavecode: null,
                    
                    },
                

                dataItems:[],

                goBtn: false,

                yearList: [],
                monthList: [],
                exchangeList: [],
                currencyList: [],
                codeList: [],            

            errMsg: '',
            isErr:false,
            editMode: false 
            }
                },
        

    methods: {
        
        
    }
}

</script>